<template>
  <v-card
    :style="`height: calc(100vh - 74px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
    class="col-12 pb-0"
  >
    <v-row
      class="mx-0 px-2"
    >
      <select-project
        v-model="project"
        class="col-2 pb-0"
      >
      </select-project>
      <v-select
        class="col-2 pb-0"
        label="Type"
        :items="types"
        v-model="type"
      />
      <v-spacer />
      <v-btn
        v-if="$store.state.auth.checkAccess({key: 'bonus_tools_update', value: true})"
        class="mt-5 ml-5"
        color="success"
        small
        @click="selected = {entity_id: project}"
      >
        Add
        <v-icon small>mdi-plus</v-icon>
      </v-btn>
    </v-row>

    <v-data-table
      :class="`bonus-tools-dt ${$store.state.auth.checkAccess({key: 'kiosk.access', value: true}) ? 'padding-footer' : ''}`"
      :loading="loading"
      :server-items-length="total"
      :headers="headers"
      :options.sync="options"
      :items="filteredItems"
      fixed-header
      :footer-props="{'items-per-page-options':[ 50, 100, 200, -1 ]}"
      :items-per-page="50"
      :height="`calc(100vh - 215px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
      style="z-index: 0; position: relative;"
    >
      <template v-slot:body.prepend>
        <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
          <td
            v-for="header in headers"
            :key="header.text"
            style="height: auto"
          >
            <v-select
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
              hide-details
              dense
              small
              multiple
              clearable
              persistent-hint
              single-line
              class="ma-0 pa-0"
              :items="filters[header.value].values || columnValueList(header.value)"
              :style="{width: (filters[header.value] || {width: false}).width}"
              v-model="filters[header.value].data"
            ></v-select>
            <v-text-field
              class="ma-0 pa-0"
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
              v-model="filters[header.value].data"
              :style="{width: (filters[header.value] || {width: false}).width}"
              hide-details
            ></v-text-field>
          </td>
        </tr>
      </template>

      <template v-slot:item.enabled="{ item }">
        {{ item.enabled ? 'Yes' : 'No' }}
      </template>
      <template v-slot:item.action="{ item }">
        <div style="white-space: nowrap">
          <v-icon small @click="selected = item">
            edit
          </v-icon>
        </div>
      </template>
    </v-data-table>

    <update-form :init="selected" v-model="dialog" />
  </v-card>

</template>

<style>
</style>

<script>

  import { get, filter } from 'lodash'
  import UpdateForm from '@/components/bonus-tools/UpdateForm'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {

    components: {
      SelectProject,
      UpdateForm
    },

    data: () => ({
      dialog: false,
      loading: false,
      type: 'period',
      project: null,
      selected: null,
      items: [],
      total: 0,
      filters: {
        benefit_id: { data: [], type: 'text' },
        alias: { data: [], type: 'text' },
        ref_id: { data: [], type: 'text' },
        name: { data: [], type: 'text' },
        type: { data: [], type: 'select' },
        enabled: { data: [], type: 'select', values: [ { text: 'Yes', value: true }, { text: 'No', value: false } ] },
      },
      types: [
        { text: 'Period', value: 'period' },
        { text: 'Autobonus', value: 'autobonus' },
        { text: 'Promotional', value: 'promo' },
        { text: 'Cashback', value: 'cashback' },
        { text: 'Retention', value: 'retention' },
        { text: 'Achievement', value: 'achievement' },
        { text: 'Journey', value: 'journey' },
        { text: 'Event', value: 'event' },
        { text: 'Lucky Box', value: 'luckybox' },
      ],
      headers: [
        { text: 'ID', value: 'benefit_id', sortable: false },
        { text: 'Alias', value: 'alias' },
        { text: 'Name', value: 'name' },
        { text: 'RefID', value: 'ref_id' },
        { text: 'Type', value: 'type' },
        { text: 'Enabled', value: 'enabled' },
        { text: '', value: 'action' },
      ],
      options: {},
    }),

    computed: {
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval(d[f].toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || (this.filters[f].data.includes((d[f] || ''))
                || (this.filters[f].data.includes(true) && ((d[f] || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((d[f] || '').toString().toLowerCase()).length == 0)
                || (typeof d[f] != 'boolean' && ((d[f] || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    watch: {
      dialog: function (val) {
        if (!val) {
          this.selected = null
        }
      },
      options: {
        handler () {
          this.search()
        },
        deep: true,
      },
      project: {
        handler () {
          this.search()
        },
      },
      type: {
        handler () {
          this.search()
        },
      },
      'filters.enabled.data': function() {
        this.search()
      }
    },

    mounted () {
      this.search()
    },

    methods: {

      columnValueList (val) {
        return filter(this.items.map(d => d[val]), (i) => i)
      },
      search: function () {
        if (this.loading == true) {
          return
        }
        this.loading = true
        try {
          API.call('/bonus_tools/list.json', {
            type: this.type,
            ...this.options,
            enabled: this.filters.enabled.data.length === 1 ? this.filters.enabled.data[0] : null,
          }, null, this.project).then(resp => {

            this.items = get(resp, 'data', [])
            if (get(resp, 'total', false)) {
              this.total = resp.total
            }
            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },
    }
  }
</script>
